import { helpers, selectors } from 'app-webtech-core';
import { ccIncreaseMenuIndex, ccMenuReset } from 'app-modules/player/actions';
import { TAB } from './types';

const remoteControllerTabButtonAction = helpers.actions.actionCreator(TAB);

export const remoteControllerTabButtonThunkAction = () => async (dispatch, getState) => {
  await dispatch(remoteControllerTabButtonAction());
  const state = getState();
  const { isCCMenuOpen, ccMenuSelectedIndexes } = selectors.player.properties(state);

  // checks to see if the cc settings menu is open
  if (isCCMenuOpen) {
    if (ccMenuSelectedIndexes.length > 1) {
      // moves the selected index to the next menu item when the index length is larger than 1
      await dispatch(ccIncreaseMenuIndex());
    } else {
      // closes the menu and resets the menu when the index length 1 or less
      await dispatch(ccMenuReset());
    }
  }
};
